import {SnackbarProvider as NotistackProvider, useSnackbar} from 'notistack'
import CloseIcon from '@mui/icons-material/Close'
import {IconButton} from '@mui/material'

const CloseButton = ({id}) => {
  const {closeSnackbar} = useSnackbar()
  return (
    <IconButton size='small' edge='end' color='inherit' onClick={() => closeSnackbar(id)}>
      <CloseIcon />
    </IconButton>
  )
}

const SnackbarProvider = ({children}) => {
  return (
    <NotistackProvider
      maxSnack={3}
      preventDuplicate
      dense
      action={key => <CloseButton key={key} id={key} />}
    >
      {children}
    </NotistackProvider>
  )
}

export default SnackbarProvider
